import { useState, useEffect } from 'react'
import { Row, Col } from 'react-bootstrap'
import { toast } from 'react-toastify'
import api from '../../../services/api'
import { Path, Truck, Clock, Star, HourglassHigh } from 'phosphor-react'
import { errorApi } from '../../../utils/errorApi'

import styles from './styles.module.css'
import { useLoading } from '../../../hooks/LoadingContext'
import { VictoryAxis, VictoryBar, VictoryChart, VictoryTheme, VictoryTooltip } from 'victory'

function DriverPerformance({ driverId, handleShowRequests, date = '' }) {
  const [performanceInfo, setPerformanceInfo] = useState({})
  const [workedDaysChartData, setWorkedDaysChartData] = useState({})

  const { setIsLoading } = useLoading()

  useEffect(() => {
    async function loadData() {
      try {
        setIsLoading(true)
        let performanceData = await api.get(`/company/drivers/${driverId}/performance?date=${date}`)

        const workedDaysData = performanceData.data.worked_days

        let monthDays = new Date(date).getMonth() + 1
        let daysInMonth = new Date(new Date().getFullYear(), monthDays, 0).getDate()

        let days = Array.from({ length: daysInMonth }, (_, i) => i + 1)

        let workedDaysChartData = days.map((day) => ({
          x: day,
          y: workedDaysData[day] || 0,
        }))

        setWorkedDaysChartData(workedDaysChartData)
        setPerformanceInfo(performanceData.data)
      } catch (err) {
        toast.error(
          errorApi(
            err,
            'Falha ao buscar as estatísticas do motorista. Tente novamente mais tarde.',
          ),
        )
      }
      setIsLoading(false)
    }
    loadData()
  }, [driverId, date, setIsLoading])

  return (
    <div>
      <Row>
        <Col className={`${styles.infoContainer} col-12 col-md-5 border`}>
          <Row>
            <Col className="col-4 text-center">
              <Clock className={styles.infoIcon} color="#053C5E" size={50} weight="light" />{' '}
            </Col>
            <Col className="col-8 text-center d-flex flex-column align-items-center justify-content-center">
              <span style={{ fontSize: 12 }}>Horas em entrega</span>
              <span className={styles.infoData}>{performanceInfo.worked_hours + ' horas'}</span>
            </Col>
          </Row>
        </Col>
        <Col className={`${styles.infoContainer} col-12 col-md-5 offset-md-1 border`}>
          <Row>
            <Col className="col-4 text-center">
              <Star className={styles.infoIcon} color="#053C5E" size={50} weight="light" />{' '}
            </Col>
            <Col className="col-8 text-center d-flex flex-column align-items-center justify-content-center">
              <span style={{ fontSize: 12 }}>Avaliação</span>
              <span className={styles.infoData}>{performanceInfo.average_rating} estrelas</span>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col className={`${styles.infoContainer} col-12 col-md-11 border`}>
          <Row className="mb-0">
            <Col className="col-2 text-center">
              <Path className={styles.infoIcon} color="#053C5E" size={50} weight="light" />{' '}
            </Col>
            <Col className="col-10 col-md-8 text-center d-flex flex-column align-items-center align-items-md-start justify-content-center">
              <span style={{ fontSize: 12 }}>Tempo em</span>
              <span className={styles.infoData}>entregas (horas)</span>
            </Col>
          </Row>

          {workedDaysChartData.length > 1 ? (
            <VictoryChart
              domainPadding={{ y: 20, x: 0 }}
              domain={{ x: [0, 32] }}
              theme={VictoryTheme.clean}
              height={200}
              padding={{ top: -20, bottom: 100, left: 50, right: 0 }}
            >
              <VictoryAxis crossAxis label="Dia do mês" />
              <VictoryAxis dependentAxis crossAxis />
              <VictoryBar
                barWidth={10}
                cornerRadius={3}
                data={workedDaysChartData}
                labelComponent={
                  <VictoryTooltip
                    cornerRadius={8}
                    dy={-5}
                    style={{
                      fill: '#FFFFFF',
                    }}
                    flyoutStyle={{
                      fill: '#053C5E',
                    }}
                  />
                }
                labels={({ datum }) => `Dia ${datum.x} \nTempo (horas): ${datum.y}`}
                style={{
                  data: {
                    fill: '#c3c3c3',
                    fillOpacity: 1,
                    stroke: '#053C5E',
                    strokeWidth: 1,
                  },
                }}
              />
            </VictoryChart>
          ) : (
            <div className={`${styles.chartInfoBadge} text-center mb-2`}>
              Nenhum dia trabalhado no período
            </div>
          )}
        </Col>
      </Row>

      <Row>
        <Col className={`${styles.infoContainer} col-12 col-md-5 border`}>
          <Row>
            <Col className="col-4 text-center">
              <Truck className={styles.infoIcon} color="#053C5E" size={50} weight="light" />{' '}
            </Col>
            <Col className="col-8 text-center d-flex flex-column align-items-center justify-content-center">
              <span style={{ fontSize: 12 }}>Média de entregas</span>
              <span className={styles.infoData}>
                {performanceInfo.requests_weekly_average + '/semana'}
              </span>
            </Col>
          </Row>
        </Col>
        <Col
          className={`${styles.infoContainer} ${styles.cardClickable} col-12 col-md-5 offset-md-1 border`}
          style={{ cursor: 'pointer' }}
          onClick={handleShowRequests}
        >
          <Row>
            <Col className="col-4 text-center">
              <HourglassHigh className={styles.infoIcon} color="#053C5E" size={50} weight="light" />{' '}
            </Col>
            <Col className="col-8 text-center d-flex flex-column align-items-center justify-content-center">
              <span style={{ fontSize: 12 }}>Duração média</span>
              <span className={styles.infoData}>
                {(performanceInfo.average_request_time_minutes || 0) + ' min'}
              </span>
              <span style={{ fontSize: 10 }}>Clique aqui</span>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default DriverPerformance
